import {Component, inject, OnInit} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {ThemeService} from './shared/services/theme.service';
import {LoadingComponent} from './shared/components/loading/loading.component';
import {ToastComponent} from './shared/components/toast/toast.component';


@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    LoadingComponent,
    ToastComponent
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  ngOnInit(): void {
  }
}
